import React from 'react';

import { Link } from 'react-router-dom';

import { css } from '@emotion/css';
import { schemas } from '@recurrency/core-api-schema';
import { RecurrencyRole, TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';

import { Counter } from 'components/Counter';
import { MiniTable } from 'components/MiniTable';

import { useCoreApi } from 'hooks/useApi';
import { useGlobalApp } from 'hooks/useGlobalApp';

import { formatDate } from 'utils/formatting';
import { arePermissionsEnabled, hasUserPermission, isRecurrencyRole } from 'utils/roleAndTenant';
import { routes } from 'utils/routes';

interface FailedValidationRulesPanelContentProps {
  itemUid: string;
  locationId: string;
}

export function FailedValidationRulesPanelContent({ itemUid, locationId }: FailedValidationRulesPanelContentProps) {
  const { activeTenant } = useGlobalApp();
  const canOpenRuleBuilder = arePermissionsEnabled()
    ? hasUserPermission(activeTenant, TenantUserPermission.AccessRuleBuilderRulesView)
    : isRecurrencyRole(activeTenant, RecurrencyRole.TenantAdmin);
  const {
    data: rulesData,
    isLoading,
    error,
  } = useCoreApi(schemas.validationRules.getCurrentValidationRuleFailures, {
    queryParams: { itemId: itemUid, locationId },
  });
  const rulesCount = rulesData?.items.length || 0;

  return (
    <>
      {rulesData && (
        <p>
          <i>Latest Run: {rulesData?.items[0] ? formatDate(rulesData?.items[0].runTime, true, true) : 'None'}</i>
          <Counter
            className={css`
              margin-left: 10px;
            `}
            value={rulesCount}
            selected={rulesCount > 0}
            variant="primary"
          />
        </p>
      )}
      <MiniTable
        data={rulesData?.items || []}
        columns={[
          {
            render: (record) =>
              canOpenRuleBuilder ? (
                <Link to={routes.ruleBuilder.ruleDetails(record.ruleId)}>{record.ruleName}</Link>
              ) : (
                record.ruleName
              ),
            align: `left`,
          },
        ]}
        isLoading={isLoading}
        error={error}
      />
    </>
  );
}
